// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/angular-ivy';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import packageJson from '../package.json';

if (environment.production) {
    enableProdMode();
}

Sentry.init({
    dsn: process.env.NG_APP_SENTRY_DSN,
    environment: environment.env,
    release: `${process.env.NG_APP_SENTRY_PROJECT ?? 'ddj-ux'}@${packageJson.version ?? '0.0.0'}`,
    integrations: [
        // Registers and configures the Tracing integration,
        // which automatically instruments your application to monitor its
        // performance, including custom Angular routing instrumentation
        new Sentry.BrowserTracing({
            tracePropagationTargets: [
                'localhost',
                'https://app-dev.digitaldealjacket.com',
                'https://app-uat.digitaldealjacket.com',
                'https://app-preprod.digitaldealjacket.com',
                'https://app.digitaldealjacket.com',
            ],
            routingInstrumentation: Sentry.routingInstrumentation,
        }),
    ],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
});

platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => console.error(err));
